import type { ReviewQuestion } from '@/types/review/ReviewQuestion';

import { api } from '@/api/api';

export interface SaveCompetencyQuestionsPayload {
    questions: ReviewQuestion[];
}

export default {
    async getCompetencyQuestions(competencyId: string): Promise<ReviewQuestion[]> {
        const response = await api.get(`/CompetencyQuestion/${competencyId}`);

        return response.data;
    },

    async saveCompetencyQuestions(
        competencyId: string,
        payload: SaveCompetencyQuestionsPayload,
    ): Promise<ReviewQuestion[]> {
        const response = await api.put(`/CompetencyQuestion/${competencyId}`, payload);

        return response.data;
    },

    async moveCompetencyQuestion(
        questionId: string,
        targetCompetencyId: string,
    ): Promise<ReviewQuestion> {
        const response = await api.put(`/CompetencyQuestion/${questionId}/move`, {
            targetCompetencyId,
        });

        return response.data;
    },
};
